// FILE: frontend/src/components/ScoreCard.jsx
// Per-turn score card with horizontal bar charts (Patricia's design)
// Appears in the message stream after the user speaks
// Visibility controlled by uiConfig.show_per_turn_feedback

import React from 'react'
import ScoreBar from './ScoreBar'

export default function ScoreCard({ score, visible }) {
  if (!visible || !score) return null

  const overall = Number(score.overall || 0)
  const justification = String(score.justification || '')

  return (
    <div className="score-card">
      <div className="score-head">
        <div className="score-title">Your Score</div>
        <div className="score-num">{overall}</div>
      </div>
      <div className="score-bars">
        <ScoreBar label="Intent Match" value={score.intent_match} />
        <ScoreBar label="Fluency" value={score.fluency} />
        <ScoreBar label="Completeness" value={score.completeness} />
        <ScoreBar label="Vocabulary" value={score.vocabulary} />
      </div>
      {justification && (
        <div className="score-tip">
          💡 {justification}
        </div>
      )}
    </div>
  )
}
